import { Bob } from "../stores/Bob";
import { makeSpreadsheetLine } from "./spreadSheet";
import { makeTransactionsListLine } from "./transactionsList";
import { makeTransactionsPage } from "./transactionViewer";
import { CurrencySnapshot } from "./types";

export interface OurInvoice {
  confirmed_at: number | null;
  created_at: number | null;
  amount_in_satoshis: number;
  payer_provided_description: string | null;
  our_provided_description: string | null;
  payment_hash: string;
  pay_request: string;
  uuid: string;
  currency_snapshot: CurrencySnapshot;
  zap_picture_url: string | null;
  zap_name: string | null;
  // settled hold invoices appear here as normal "Received"; the flag lets
  // setOurInvoices leave their celebration to the Hold Invoices page
  is_hold_invoice?: boolean;
}

export const makeSpreadsheetLineForOurInvoice = (
  invoiceData: OurInvoice,
  bob: Bob
) => {
  return makeSpreadsheetLine({
    type: "Lightning Invoice",
    status: invoiceData.confirmed_at ? "Paid" : "Unpaid",
    uuid: invoiceData.uuid,
    createdAtInteger: invoiceData.created_at,
    currencySnapshot: invoiceData.currency_snapshot,
    currency: bob.currencyCode,
    amountSatoshis: invoiceData.amount_in_satoshis,
    isCredit: true,
    comment:
      invoiceData.payer_provided_description ||
      invoiceData.our_provided_description ||
      null,
    payRequest: invoiceData.pay_request || null,
    routingFeeSatoshis: null,
    platformFeeSatoshis: null,
    lightningAddress: null,
  });
};

export const makeTransactionsListLineForOurInvoice = (
  invoiceData: OurInvoice,
  bob: Bob
) => {
  const isThisConfirmed = invoiceData.confirmed_at !== null;
  return makeTransactionsListLine({
    amountSatoshis: invoiceData.amount_in_satoshis,
    label: isThisConfirmed ? "Received" : "Invoice Created",
    isConfirmed: isThisConfirmed,
    createdAtInteger: isThisConfirmed
      ? invoiceData.confirmed_at
      : invoiceData.created_at,
    comment:
      invoiceData.payer_provided_description ||
      invoiceData.our_provided_description ||
      null,
    currencySnapshot: invoiceData.currency_snapshot,
    currency: bob.currencyCode,
    isCredit: true,
    modelName: "OurInvoice",
    uuid: invoiceData.uuid,
    lightningAddress: null,
    zapName: invoiceData.zap_name,
    zapPictureUrl: invoiceData.zap_picture_url,
  });
};

export const makeTransactionPageDataForOurInvoice = (
  invoiceData: OurInvoice,
  bob: Bob
) => {
  const isConfirmed = invoiceData.confirmed_at !== null;
  return makeTransactionsPage({
    header: isConfirmed ? "Received" : "Unpaid Invoice",
    uuid: invoiceData.uuid,
    createdAtInteger: invoiceData.created_at,
    currencySnapshot: invoiceData.currency_snapshot,
    currency: bob.currencyCode,
    amountSatoshis: invoiceData.amount_in_satoshis,
    isCredit: true,
    comment:
      invoiceData.payer_provided_description ||
      invoiceData.our_provided_description ||
      null,
    payRequest: invoiceData.pay_request || null,
    routingFeeSatoshis: null,
    platformFeeSatoshis: null,
    lightningAddress: null,
  });
};
